var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 459 c-3 -4 -24 -14 -45 -20 -22 -7 -40 -18 -40 -26 0 -8 -13 -26 -29 -41 -37 -35 -48 -93 -35 -177 4 -26 17 -50 35 -67 16 -15 29 -34 29 -42 0 -9 6 -16 13 -16 7 0 29 -8 50 -19 48 -25 130 -25 177 0 19 11 40 19 47 19 7 0 13 7 13 16 0 8 13 27 29 42 18 17 31 41 35 67 13 84 2 142 -35 177 -16 15 -29 34 -29 42 0 9 -6 16 -13 16 -7 0 -28 8 -47 19 -37 19 -145 27 -155 10z m165 -118 c0 -12 -111 -181 -119 -181 -12 0 -85 79 -79 85 3 4 22 -8 43 -26 21 -19 40 -28 43 -23 4 6 27 42 52 82 41 66 60 86 60 63z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.8589bda418c76e435c265090ff9bf9f6.svg";
export { ForwardRef as ReactComponent };